export const maxLogsForDiagnosticsPanel = 100;
